import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Auto-applies marketplace filters with a debounce and swaps only the results
// column via a turbo_stream response, keeping the sidebar (scroll, open
// collapses, checkbox order) untouched.
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  connect() {
    this.timer = null
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  // Debounced trigger wired to `change` (checkboxes) and `input` (text/price).
  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  async submit() {
    const params = new URLSearchParams()
    for (const [key, value] of new FormData(this.element).entries()) {
      if (value !== "" && value != null) params.append(key, value)
    }

    const query = params.toString()
    const url = query ? `${this.element.action}?${query}` : this.element.action

    // Keep the address bar in sync so pagination, sharing and back/forward work.
    Turbo.navigator.history.replace(new URL(url, window.location.origin))

    const results = document.getElementById("marketplace-results")
    if (results) {
      results.style.opacity = "0.5"
      results.setAttribute("aria-busy", "true")
    }

    try {
      const response = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })
      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
      }
    } catch (error) {
      console.error("Filter update failed:", error)
      if (results) {
        results.style.opacity = ""
        results.removeAttribute("aria-busy")
      }
    }
  }
}
